import {useState} from 'react'
import useApi from '../../../services/useApi'
import {parseOutOfStockOccurrenceData} from '../parsings'

const useOutOfStockOccurenceOperations = () => {
  const Api = useApi()
  const [isLoading, setLoading] = useState(false)
  const [productVariants, setProductVariants] = useState<any[]>([])

  const getOutOfStockOccurenceDetails = async (
    parentSku: string | null,
    variantSku?: string | null
  ) => {
    const filters = variantSku ? {variant_sku: variantSku} : {}
    const url = `/analytics/replenishment/products/out-of-stock/occurence/${parentSku}/details`
    return Api.get(url, {
      filters,
      setLoading: setLoading,
      onSuccess: ({data}) => {
        setProductVariants(parseOutOfStockOccurrenceData(data?.data || []))
      },
    })
  }

  return {
    productVariants,
    isOperationLoading: isLoading,
    getOutOfStockOccurenceDetails,
  }
}

export default useOutOfStockOccurenceOperations
